import classNames from 'classnames';
import { ReactElement } from 'react';

type SimpleChildElementModel = {
    type: string;
    props: {
        children: string | Array<string | SimpleChildElementModel>;
        className: string;
        id: string;
    };
};

export type IAccordionMarketingCardProps = {
    backgroundsurface: SupportedBackgroundColor;
    textcolor: SupportedTextColor;
    imageurl: string;
    children: ReactElement<SimpleChildElementModel>[];
};

const AccordionMarketingCard = ({
    backgroundsurface,
    textcolor,
    imageurl,
    children,
}: React.PropsWithChildren<IAccordionMarketingCardProps>) => {
    return (
        <section className={classNames(backgroundsurface, textcolor, 'grid grid-cols-12 gap-4')}>
            <div className="col-span-12 md:col-span-3 lg:col-span-2 flex justify-center">
                <div className="p-2">
                    <img src={imageurl} width={85} height={85} alt="" />
                </div>
            </div>
            <div className="col-span-12 md:col-span-9 lg:col-span-10 text-center md:text-start md:pr-6">
                {children}
            </div>
        </section>
    );
};

export default AccordionMarketingCard;
